export const ROUTE_NAME = {
  HomeScreen: "/homeScreen",
  LoginScreen: "/loginScreen",
  PlayWithFriend: "/playWithFriend",
  PlayWithComputer: "/playWithComputer",
  PlayOnline: "/playOnline",
  SelectPlayer: "/selectPlayer",
  PlayerRoom: "/playerRoom",
  WaitingRoom: "/WaitingRoom",
  EditProfile: "/editProfile",
  InPurchaseScreen: "/inPurchaseScreen",
  LuckySpinScreen: "/luckySpinScreen",
  // random online play routes
  RandomOnlinePlay: "/randomOnlinePlay",
  RandomPlayerRoom: "/randomPlayerRoom",
  RandomWaitingRoom: "/randomWaitingRoom",
};
